module.exports = __webpack_public_path__ + "static/projekt_indywidualny_a04-494d5708d9ba59852c3133f227c5d733.jpg";